import React, { forwardRef, useEffect } from "react";

import { styled } from "@mui/material/styles";
import SimpleBar from "simplebar-react";
const ScrollbarRoot = styled(SimpleBar)``;

// eslint-disable-next-line react/display-name
export const Scrollbar = forwardRef((props, ref) => {
  return <ScrollbarRoot ref={ref} {...props} />;
});
